const totalMessageHeight = (total, element) => {
  return total + element.scrollHeight;
};

export const calculateScrollTop = (
  conversationPanelHeight,
  parentHeight,
  relevantMessages
) => {
  // add up scrollHeight of a `relevantMessages`
  let combinedMessageScrollHeight = [...relevantMessages].reduce(
    totalMessageHeight,
    0
  );
  return (
    conversationPanelHeight - combinedMessageScrollHeight - parentHeight / 2
  );
};

/**
 * The reply box is the last in-flow child of the scrolling messages panel, so when it
 * grows the panel keeps its `scrollTop` and the composer (with its send button) slides
 * out of the viewport. This returns the `scrollTop` that keeps the composer visually
 * pinned in place, or `null` when no adjustment is needed.
 */
export const calculateScrollTopOnFooterGrowth = ({
  scrollTop,
  scrollHeight,
  clientHeight,
  growth,
  previousFooterHeight,
}) => {
  // Shrinking needs no help: when pinned to the bottom the browser clamps `scrollTop`
  // on its own, and when scrolled up nothing above the footer moves.
  if (growth <= 0) return null;

  // How far the panel was from the bottom before the footer grew.
  const distanceFromBottom = scrollHeight - growth - clientHeight - scrollTop;

  // The footer was entirely below the fold, so the user is reading history further up.
  // Leave their position alone.
  if (distanceFromBottom >= previousFooterHeight) return null;

  // The browser clamps this to the maximum scroll position.
  return scrollTop + growth;
};
